/* istanbul ignore file */
import React, { ReactNode } from 'react';
import { ListBreadcrumbItem, Breadcrumbs } from 'framework/ui/BreadCrumbs';

const OpportunitiesBreadcrumbs = ({ children }: { children?: ReactNode | ReactNode[] }) => {
  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Opportunities" link="/crm/opportunities" />
      {children}
    </Breadcrumbs>
  );
};

export default OpportunitiesBreadcrumbs;
